import { createRoute } from "@tanstack/react-router";
import { SettingsForm } from "@/components/case/settings-form";
import {
  publishedVersionIds,
  useCaseDetail,
} from "@/hooks/use-case-detail";
import { caseLayoutRoute } from "./case-layout-route";

export const caseSettingsRoute = createRoute({
  getParentRoute: () => caseLayoutRoute,
  path: "/settings",
  component: CaseSettingsPage,
});

function CaseSettingsPage() {
  const { caseId } = caseSettingsRoute.useParams();
  const detailQuery = useCaseDetail(caseId);

  if (!detailQuery.data) return null;

  const hasPublishedVersion =
    publishedVersionIds(detailQuery.data).size > 0 ||
    detailQuery.data.versions.some((v) => v.status === "published");

  return (
    <SettingsForm
      caseId={caseId}
      caseRow={detailQuery.data.case}
      hasPublishedVersion={hasPublishedVersion}
    />
  );
}
